<template>
	<div v-if="user">
		<div v-mdb-resize:start="checkWidth">
			<!-- <mdb-side-nav-2 v-model="show" :data="navigation" color="white" :over="over" :sidenav-class="['grey', 'darken-3']" :width="285"> -->
			<mdb-side-nav-2 v-model="show" color="white" :over="over" :sidenav-class="['grey', 'darken-3']"
				:width="260">
				<mdb-navbar slot="nav" tag="div" position="top" color="teal" class="darken-4" dark :toggler="false"
					:style="{ zIndex: '1061' }">
					<mdb-navbar-nav left>
						<mdb-icon icon="bars" class="white-text ml-1" size="lg" @click.native="show = !show" />
					</mdb-navbar-nav>
					<mdb-navbar-nav class="nav-flex-icons" right>
						<span class="text-white py-2">SMS-FAST</span>
					</mdb-navbar-nav>
				</mdb-navbar>

				<div slot="header" class="mt-4">
					<div class="bg-white pb-3 mb-3" style="margin: -5px;">
						<div class="row justify-content-center">
							<div class="p-3 mt-4">
								<div class="bg-G">
									<div class="norwarp-company">
										{{ user.company_name }}
									</div>
								</div>
							</div>
						</div>
						<div class="row justify-content-center color_back font12">
							<div class="col-5">
								<label class="font600 ml-4">ชื่อบริษัท :</label>
							</div>
							<div class="col-7">
								<span>{{ user.company_name }}</span>
							</div>
							<div class="col-5">
								<label class="font600 ml-4">ชื่อผู้ใช้ :</label>
							</div>
							<div class="col-7">
								<span>{{ user.username }}</span>
							</div>
								<div class="col-5">
								<label class="font600 ml-4">ประเภทสมาชิก :</label>
							</div>
							<div class="col-7">
								<span>{{ user.type_member }}</span>
							</div>
							<div class="col-5">
								<label class="font600 ml-4">เครดิต :</label>
							</div>
							<div class="col-7">
								<span>{{ currencyFormat(user.credit) }}</span>
							</div>
							<!-- <div v-if="isShowing !== false">
								<div class="row justify-content-center"> -->
							<div class="col-5">
								<label class="font600 ml-4">แผนก :</label>
							</div>
							<div class="col-7">
								<label>{{ user.cus_department }}</label>
							</div>
							<div class="col-5">
								<label class="font600 ml-4">หมดอายุ :</label>
							</div>
							<div class="col-7">
								<label>{{ user.exp_date }}</label>
							</div>
							<!-- <div class="text-center font11 color_orange mt-2">Account Information</div>
							<div class="col-12 text-center">
								<mdb-icon icon="angle-double-up fa-13  color_orange" class="mt-1 mb-3" style="cursor: pointer;" @click.native="isShowing = !isShowing" />
							</div>
							</div>
							</div>
							<div class="row justify-content-center color_orange" v-else>
								<div class="text-center font11 color_orange mt-2">Account Information</div>
								<div class="col-12 text-center">
									<mdb-icon icon="angle-double-down fa-13" class="mt-1 mb-3" style="cursor: pointer;" @click.native="isShowing = !isShowing" />
								</div>
							</div> -->
						</div>
					</div>
					<div v-if="user.user_group != 98">
						<div class="col-12 mt-3">
							<div class="nav-pills">
								<div class="nav-link" id="HomePage" @click="selectMenu('HomePage', 'HomePage')"
									:class="'bg-menu-white active'">
									<i class="fa fa-home fa-09"></i> หน้าหลัก
								</div>
								<div class="nav-link" id="Setupsender" @click="selectMenu('Setupsender', 'Setupsender')"
									:class="'bg-menu-white'">
									<i class="fa fa-paper-plane fa-09"></i> ตั้งค่าผู้ส่ง
								</div>
								<div class="nav-link bg-menu-white" id="Sendmessage">
									<span @click="selectMenu('Sendmessage', 'Sendmessage')">
										<i class="fas fa-comment-dots"></i> ส่งข้อความ
									</span>
									<div v-if="menuli == 'Sendmessage'">
										<div class="font16 mt-1" id="EditSendmessage"
											@click="selectMenu('EditSendmessage', 'Sendmessage')"
											style="margin-left: 28px;">
											- แก้ไขการส่งข้อความ
										</div>
									</div>
								</div>
						
								<div class="nav-link bg-menu-white" id="Messagereport">
									<span @click="selectMenu('Messagereport', 'Messagereport')">
										<i class="fas fa-history"></i> ประวัติการส่งข้อความ
									</span>
									<div v-if="menuli == 'Messagereport'">
										<div class="font16 mt-1" id="Messagereport"
											@click="selectMenu('Messagereport', 'Messagereport')"
											style="margin-left: 28px;">
											- รายงานการส่งข้อความ
										</div>
										<!-- <div class="font16" id="Takeoutreport" @click="selectMenu('Takeoutreport', 'Messagereport')" style="margin-left: 28px;">
										- นำออกรายงาน
                  </div>-->
									</div>
								</div>
								<div class="nav-link bg-menu-white" id="Topuplist"
									@click="selectMenu('Topuplist', 'Topuplist')">
									<i class="fas fa-donate"></i> รายการเติมเงิน
								</div>
								<div class="nav-link bg-menu-white" id="Setuser">
									<span @click="selectMenu('Setuser', 'Setuser')">
										<i class="fas fa-user-cog"></i> ตั้งค่าข้อมูลผู้ใช้
									</span>
									<div v-if="menuli == 'Setuser'">
										<div class="font16" id="Setuser" @click="selectMenu('Setuser', 'Setuser')"
											style="margin-left: 28px;">
											- ข้อมูลสมุดโทรศัพท์
										</div>
										<div class="font16 mt-1" id="Usagedata"
											@click="selectMenu('Usagedata', 'Setuser')" style="margin-left: 28px;">
											- ข้อมูลการใช้งาน
										</div>
									</div>
								</div>
								<div class="nav-link bg-menu-white" id="Logout" @click="Logout()">
									<mdb-icon icon="door-open" /> ออกจากระบบ
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="col-12 mt-3 mx-0 px-0">
							<p class="title-cat-menu">
								<i class="fas fa-cogs mr-2"></i>เมนูผู้ใช้งาน
							</p>
							<div class="nav-pills">
								<div class="nav-link" id="HomePage" @click="selectMenu('HomePage', 'HomePage')"
									:class="'bg-menu-white active'">
									<i class="fa fa-home fa-09"></i> หน้าหลัก
								</div>
								<div class="nav-link" id="Setupsender" @click="selectMenu('Setupsender', 'Setupsender')"
									:class="'bg-menu-white'">
									<i class="fa fa-paper-plane fa-09"></i> ตั้งค่าผู้ส่ง
								</div>
								<div class="nav-link bg-menu-white" id="Sendmessage">
									<span @click="selectMenu('Sendmessage', 'Sendmessage')">
										<i class="fas fa-comment-dots"></i> ส่งข้อความ
									</span>
									<div v-if="menuli == 'Sendmessage'">
										<div class="font16 mt-1" id="EditSendmessage"
											@click="selectMenu('EditSendmessage', 'Sendmessage')"
											style="margin-left: 28px;">
											- แก้ไขการส่งข้อความ
										</div>
									</div>
								</div>
								<div class="nav-link bg-menu-white" id="Messagereport">
									<span @click="selectMenu('Messagereport', 'Messagereport')">
										<i class="fas fa-history"></i> ประวัติการส่งข้อความ
									</span>
									<div v-if="menuli == 'Messagereport'">
										<div class="font16 mt-1" id="Messagereport"
											@click="selectMenu('Messagereport', 'Messagereport')"
											style="margin-left: 28px;">
											- รายงานการส่งข้อความ
										</div>
										<!-- <div class="font16" id="Takeoutreport" @click="selectMenu('Takeoutreport', 'Messagereport')" style="margin-left: 28px;">
										- นำออกรายงาน
                  </div>-->
									</div>
								</div>
								<div class="nav-link bg-menu-white" id="Topuplist"
									@click="selectMenu('Topuplist', 'Topuplist')">
									<i class="fas fa-donate"></i> รายการเติมเงิน
								</div>
								<div class="nav-link bg-menu-white" id="Setuser">
									<span @click="selectMenu('Setuser', 'Setuser')">
										<i class="fas fa-user-cog"></i> ตั้งค่าข้อมูลผู้ใช้
									</span>
									<div v-if="menuli == 'Setuser'">
										<div class="font16" id="Setuser" @click="selectMenu('Setuser', 'Setuser')"
											style="margin-left: 28px;">
											- ข้อมูลสมุดโทรศัพท์
										</div>
										<div class="font16 mt-1" id="Usagedata"
											@click="selectMenu('Usagedata', 'Setuser')" style="margin-left: 28px;">
											- ข้อมูลการใช้งาน
										</div>
									</div>
								</div>
								<!-- <div class="nav-link bg-menu-white" id="Logout" @click="Logout()">
									<mdb-icon icon="door-open" /> ออกจากระบบ
								</div> -->
							</div>
							<p class="title-cat-menu">
								<i class="fas fa-cogs mr-2"></i>เมนูจัดการระบบ
							</p>
							<div class="nav-pills">
								<div class="nav-link" id="Manageuser" @click="selectMenu('Manageuser', 'Manageuser')"
									:class="'bg-menu-white active'">
									<i class="fa fa-paper-plane fa-09"></i> จัดการผู้ใช้งาน
								</div>
								<div class="nav-link" id="Managepromotion"
									@click="selectMenu('Managepromotion', 'Managepromotion')" :class="'bg-menu-white'">
									<i class="fa fa-bullhorn fa-09"></i> จัดการโปรโมชั่น
								</div>
								<div class="nav-link bg-menu-white" id="Managecredit"
									@click="selectMenu('Managecredit', 'Managecredit')">
									<i class="fas fa-donate"></i> จัดการเครดิต
								</div>
								<div class="nav-link bg-menu-white depositlist-sub" id="Depositlist"
									@click="selectMenu('Depositlist', 'Depositlist')">
									<i class="fas fa-hand-holding-usd mr-2"></i>รายการฝาก
								</div>
								<div class="submenu-main" id="submenu-deposit">
									<div class="nav-link bg-menu-white" id="Depositdemical"
										@click="selectMenu('Depositdemical', 'Depositdemical')">
										- รายการฝากทศนิยม
									</div>
									<div class="nav-link bg-menu-white" id="RemainwaitConfirm" @click="
                      selectMenu('RemainwaitConfirm', 'RemainwaitConfirm')
                    ">
										- รายการตกค้างรอยืนยัน
									</div>
									<div class="nav-link bg-menu-white" id="ListDeposit"
										@click="selectMenu('ListDeposit', 'ListDeposit')">
										- แสดงรายการฝาก
									</div>
								</div>
								<div class="nav-link bg-menu-white state-sub" id="Bankstatement"
									@click="selectMenu('Bankstatement', 'Bankstatement')">
									<i class="fas fa-money-check-alt mr-2"></i>ข้อมูลสเตทเม้นธนาคาร
								</div>
									<div class="submenu-main" id="submenu-state">
								<div class="nav-link bg-menu-white" id="AccountDeposit"
									@click="selectMenu('AccountDeposit', 'AccountDeposit')">
									- ข้อมูลบัญชีฝาก
								</div>
								<div class="nav-link bg-menu-white" id="AddAccountDeposit"
									@click="selectMenu('AddAccountDeposit', 'AddAccountDeposit')">
									- เพิ่มข้อมูลบัญชีฝาก
								</div>
								</div>
																<div class="nav-link bg-menu-white" id="Usagedata"
									@click="selectMenu('Usagedata', 'Usagedata')">
									<i class="fas fa-calendar-alt"></i> ประวัติการใช้งาน
								</div>
								<div class="nav-link bg-menu-white" id="Logout" @click="Logout()">
									<mdb-icon icon="door-open" /> ออกจากระบบ
								</div>
							</div>
						</div>
					</div>

					<!-- <div class="text-center">
						<img class="img-foot" alt="logo" src="/images/logo/sms_fast_white.png" width="100%;"
							style="max-width: 180px;" />
					</div> -->
				</div>
				<div style="height:280vh; " slot="main" class="mt-5">
					<div class="view intro-2">
						<div class="full-bg-img">
							<div class="mask rgba-white-strong">
								<div class="dark-grey-text">
									<Page />
								</div>
							</div>
						</div>
					</div>
				</div>
			</mdb-side-nav-2>
		</div>
		<Modalcheck></Modalcheck>
	</div>
</template>
<script>
	import Modalcheck from "../views/modalcheck";
	import momentjs from "moment";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	import Page from "../views/Page";
	import $ from "jquery";
	import {
		mdbResize
	} from "mdbvue";
	export default {
		name: "menulift",
		components: {
			Page,
			Modalcheck,
		},
		data() {
			return {
				isShowing: false,
				menu: [],
				menuli: null,
				show: true,
				over: false,
				users: {},
				datetime: null,
				contectline: "https://line.me/R/ti/p/%40432dusyp",
			};
		},
		directives: {
			mdbResize,
		},
		computed: {
			...mapGetters({
				isLogin: "isLogin",
				user: "user",
				token: "token",
			}),
		},
		async mounted() {
			this.datetime = momentjs(new Date()).format("YYYY-MM-DD");
			await this.loadsession();
			if (localStorage.getItem("tokens")) {
				if (new Date().getTime() <= localStorage.getItem("timeout")) {
					if (this.$route.name == "Menulift") {
						if (this.user.user_group == 98) {
							this.$router.push("/HomePage");
						} else {
							this.$router.push("/");
						}
					} else {
						this.$router.push(this.$route.fullPath);
						setTimeout(() => {
							this.selectMenu2(this.$route.name, this.$route.name);
						}, 100);
					}
				} else {
					this.$router.push("/Logout");
				}
			} else {
				if (!this.isLogin) {
					this.$router.push("/Logout");
				}
			}
		},
		methods: {
			...mapActions({
				storeLogin: "login",
				storeLoout: "logout",
				loadsession: "loadsession",
				callApiMotherFucker: "callApiMotherFucker",
			}),
			currencyFormat(n) {
				n = parseFloat(n);
				return n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
			},
			checkWidth() {
				this.over = window.innerWidth < 900;
			},
			async selectMenu(menu, idmenu) {
				if (this.user.exp_date >= this.datetime) {
					await this.loadsession();
					$(".bg-menu-white").removeClass("active");
					$("#" + idmenu).addClass("active");
					this.menuli = idmenu;
					this.$router.push(menu);
				} else {
					if (
						menu == "Setupsender" ||
						menu == "Sendmessage" ||
						menu == "Setuser" ||
						menu == "Setusers"
					) {
						// if (menu == 'Setusers') {
						// 	this.menuli = idmenu
						// 	this.$router.push('Usagedata')
						// }
						this.$swal({
							// icon: 'info',
							// html: '<div>แพ็กเกจหมดอายุ กรุณาติดต่อพนักงาน</div><a href="' + this.contectline + '" target="_blank" class="green-text mt-2">@LINE CLICK</a>',
							html: '<div class="mt-3"><img src="/images/line.png" width="150px"/></div><div>แพ็กเกจหมดอายุ กรุณาติดต่อพนักงาน</div>',
							showConfirmButton: true,
							allowEscapeKey: false,
						});
					} else {
						await this.loadsession();
						$(".bg-menu-white").removeClass("active");
						$("#" + idmenu).addClass("active");
						this.menuli = idmenu;
						this.$router.push(menu);
					}
				}
			},
			async selectMenu2(menu, idmenu) {
				await this.loadsession();
				$(".bg-menu-white").removeClass("active");
				$("#" + idmenu).addClass("active");
// 				$(".depositlist-sub").click(function() {
// 					$("#submenu-deposit").slideToggle(400);
//   $("#submenu-deposit").toggleClass( "active" );
// });
// 	$(".state-sub").click(function() {
// 					$("#submenu-state").slideToggle(400);
//   $("#submenu-state").toggleClass( "active" );
// });
				this.menuli = idmenu;
			},
			Logout() {
				return this.$swal({
					html: '<i class="fa fa-door-open fa-6x"></i><br><br>ยืนยันการออกจากระบบ<br>',
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true,
					showConfirmButton: true,
					cancelButtonColor: "#d33",
					confirmButtonText: "ยืนยัน",
					cancelButtonText: "ยกเลิก",
				}).then((result) => {
					if (result.value) {
						this.$router.push("/Logout");
					}
				});
			},
		},
	};
</script>
<style scoped>
/* .submenu-main{
	display: none;
} */
	.bg-G {
		position: sticky;
		width: 81px;
		height: 81px;
		background: #f5904b;
		top: 20px;
		font-size: 36px;
		color: #ffffff;
		padding: 13px 25px 14px 28px;
		border-radius: 50px;
	}

	.view {
		/* background: url('https://mdbootstrap.com/img/Photos/Others/img (52).jpg') no-repeat center center; */
		background-size: cover;
		height: 100%;
	}

	.navbar i {
		cursor: pointer;
		color: white;
	}

	.teal.darken-4 {
		background-color: #f5904b !important;
	}

	.img-foot {
		position: absolute;
		bottom: 20px;
		left: 52px;
	}

	.bg-Menu:active {
		background: #ffffff;
		border-radius: 10px;
	}

	.nav-pills .nav-link.active,
	.nav-pills .show>.nav-link {
		color: #f5904b;
		background-color: #ffffff;
	}

	.nav-pills .nav-link:hover,
	.nav-pills .show>.nav-link {
		/* color: #f5904b;
		background-color: #ffffff; */
		cursor: pointer;
	}

	.fa-09 {
		font-size: 0.9em;
	}

	.fa-13 {
		font-size: 1.3em;
	}

	.title-cat-menu {
		margin: 0 0 10px;
		background: #464646;
		padding: 3px 10px;
		border-radius: 5px;
	}
</style>